import React, { useEffect, useState } from 'react';
import { useGetOrdersQuery } from '../../apis/mlkApi/mlk.api.hooks';
import { BaseLayout } from '../../components/Layout/Layout';
import { TextField } from '../../components/TextField/TextField';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';
import { Order } from '../../models';
import { OrderElement } from './components/OrderElement/OrderElement';

import searchImage from '../../assets/images/search-shipper.png';

import './OrdersView.css';
import { useOrderId } from '../../hooks/useOrderId';
import { getExpectedServiceDateAndTimeSlot } from '../../helpers/order';

type OrdersViewProps = {};

export const OrdersView: React.FC<OrdersViewProps> = () => {
  const [t] = useLanguage();
  const goBack = useBack();
  const orderId = useOrderId(true);

  const [searchText, setSearchText] = useState('');
  const [filteredOrders, setFilteredOrders] = useState<Order[]>([]);

  const { data: ordersData } = useGetOrdersQuery(undefined);

  useEffect(() => {
    if (ordersData) {
      const filteredOptions = ordersData.orders.filter((o) =>
        (o.shipper.alias || o.shipper.name)
          .toLowerCase()
          .includes(searchText.toLowerCase())
      );
      filteredOptions.sort((a, b) => {
        const serviceDateA = getExpectedServiceDateAndTimeSlot(a);
        const serviceDateB = getExpectedServiceDateAndTimeSlot(b);

        if (!serviceDateA) return 1;
        if (!serviceDateB) return -1;

        const isABefore = serviceDateA.from.isBefore(serviceDateB.from);

        if (isABefore) return 1;

        return -1;
      });
      setFilteredOrders(filteredOptions);
    }
  }, [ordersData, searchText]);

  return (
    <BaseLayout
      hasMenu={!orderId}
      hasBack={Boolean(orderId)}
      onBackClick={goBack}
      title={t('pageTitles.orders')}
    >
      <TextField
        isPlaceholderItalic
        value={searchText}
        onValueChange={setSearchText}
        node={
          <img alt="Search image" width={30} height={30} src={searchImage} />
        }
        placeholder={t('searchOrder.searchPlaceholder')}
      />
      {filteredOrders.map((o) => {
        return (
          <React.Fragment key={o.id}>
            <OrderElement order={o} />
          </React.Fragment>
        );
      })}
    </BaseLayout>
  );
};
